import React from "react";

/**
 * TrendBadge
 * - Shows ▲/▼ with delta when materially changed
 * - Shows "Maintained" (neutral) when flat or no recent delta
 * - deadband: treat very small changes as flat (e.g., < 0.1)
 * - unit is optional (e.g., " mph" or " pp")
 */
const TrendBadge = ({ label, delta, unit = "" }) => {
  const isNum = typeof delta === "number" && !Number.isNaN(delta);
  const deadband = 0.1; // change threshold (tune if needed)
  let state = "flat";
  let abs = 0;

  if (isNum) {
    abs = Math.abs(delta);
    if (abs > deadband) state = delta > 0 ? "up" : "down";
  } else {
    // null/undefined → treat as flat/maintained
    state = "flat";
  }

  const base = "px-2 py-1 rounded-md text-xs border border-white/10";
  const cls =
    state === "up"
      ? `${base} bg-emerald-700/30` 
      : state === "down"
      ? `${base} bg-rose-700/30` 
      : `${base} bg-slate-600/30 text-slate-200`;

  return (
    <div className={cls} aria-label={`${label} trend`}>
      <span className="font-semibold">{label}:</span>{" "}
      {state === "flat" ? (
        <span className="font-medium">Maintained</span>
      ) : (
        <span className="font-bold">
          {state === "up" ? "▲" : "▼"} {abs.toFixed(1)}
          {unit}
        </span>
      )}
    </div>
  );
};

export default TrendBadge;
